export const ADMIN_TIME_ZONE = 'Europe/Paris';

const partsFormatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: ADMIN_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23'
});

type DateTimeFields = { date: string; time: string };

const partsAt = (timestamp: number) => Object.fromEntries(
    partsFormatter.formatToParts(new Date(timestamp))
        .filter(part => part.type !== 'literal')
        .map(part => [part.type, Number(part.value)])
) as Record<string, number>;

export function dateTimeFieldsInParis(value: string | null): DateTimeFields {
    if (!value) return { date: '', time: '' };
    const timestamp = new Date(value).valueOf();
    if (Number.isNaN(timestamp)) return { date: '', time: '' };
    const parts = partsAt(timestamp);
    const pad = (number: number) => String(number).padStart(2, '0');
    return {
        date: `${parts.year}-${pad(parts.month)}-${pad(parts.day)}`,
        time: `${pad(parts.hour)}:${pad(parts.minute)}`
    };
}

export function parisFieldsToIso(date: string, time: string): string | null {
    const match = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})$/.exec(`${date} ${time}`);
    if (!match) return null;
    const expected = {
        year: Number(match[1]), month: Number(match[2]), day: Number(match[3]),
        hour: Number(match[4]), minute: Number(match[5]), second: 0
    };
    const wallClockAsUtc = Date.UTC(
        expected.year, expected.month - 1, expected.day, expected.hour, expected.minute
    );
    let timestamp = wallClockAsUtc;
    for (let attempt = 0; attempt < 3; attempt += 1) {
        const parts = partsAt(timestamp);
        const offset = Date.UTC(
            parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second
        ) - timestamp;
        timestamp = wallClockAsUtc - offset;
    }
    const actual = partsAt(timestamp);
    if (Object.keys(expected).some(key => actual[key] !== expected[key])) return null;
    return new Date(timestamp).toISOString();
}

export function formatInParis(value: string | null): string {
    if (!value) return '—';
    const date = new Date(value);
    if (Number.isNaN(date.valueOf())) return 'Date invalide';
    return new Intl.DateTimeFormat('fr-FR', {
        timeZone: ADMIN_TIME_ZONE,
        dateStyle: 'short',
        timeStyle: 'short'
    }).format(date);
}
